module.exports = __webpack_public_path__ + "img/train-5.1db5710c.jpg";